import { configureStore } from '@reduxjs/toolkit'
import packages from './reducers/packagesSlice'
import bookings from './reducers/bookingsSlice'
import configurations from './reducers/configSlice'
import defaultconfigurations from './reducers/defaultConfigSlic'

import profile from './reducers/agencyProfileSlice'
import instructions from './reducers/instructionsSlice'
import parties from './reducers/partiesSlice'
import partiesStats from './reducers/partiesBookingStatsSlice'
import vouchercolors from './reducers/voucherColorsSlice'

import collapsed from './reducers/collpseSlice'
export const store = configureStore({
  reducer: {
    packages,
    collapsed,
    bookings,
    configurations,
    defaultconfigurations,
    profile,
    instructions,
    parties,
    partiesStats,
    vouchercolors
  }
})